export const DELAY_BETWEEN_MESSAGES = 600;
export const DAY = 1000 * 60 * 60 * 24;

export enum ACTIONS {
  // modal
  MODAL_OPEN = 'MODAL_OPEN',
  MODAL_CLOSE = 'MODAL_CLOSE',
  // meta
  META_UPDATE_PAGE_URL = 'META_UPDATE_PAGE_URL',
  META_UPDATE_INTENT_ID = 'META_UPDATE_INTENT_ID',
  META_UPDATE_ORIG_PARAMS = 'META_UPDATE_ORIG_PARAMS',
  META_UPDATE_DEALER_OFFER_PARAMS = 'META_UPDATE_DEALER_OFFER_PARAMS',
  META_UPDATE_ARTICLE_URI = 'META_UPDATE_ARTICLE_URI',
  // inputs focus
  INPUTS_FOCUS_SEARCH = 'INPUTS_FOCUS_SEARCH',
  // widget
  SET_WIDGET_SESSION = 'SET_WIDGET_SESSION',
  // root actions
  RESET_CHATBOT_STATE = 'RESET_CHATBOT_STATE',
}

export enum ROLE {
  BOT,
  USER,
}

export enum MESSAGES {
  ARTICLE = ':ARTICLE',
  BOT_MESSAGE = ':BOT_MESSAGE',
  AI_ARTICLE_ANSWER = ':AI_ARTICLE_ANSWER',
  TITLE_BOT_MESSAGE = ':TITLE_BOT_MESSAGE',
  BOT_TYPING = ':BOT_TYPING',
  USER_MESSAGE = ':USER_MESSAGE',
  BUTTONS = ':BUTTONS',
  BUTTONS_VERTICAL = ':BUTTONS_VERTICAL',
  PHONE = ':PHONE_SELECTOR',
  VIDEO = ':VIDEO',
  IMAGE = ':IMAGE',
  // selectors
  CATEGORY = ':CATEGORY',
  SITE_SELECTOR = ':SITE_SELECTOR',
  DOMAIN_SELECTOR = ':DOMAIN_SELECTOR',
  PLAN_SELECTOR = ':PLAN_SELECTOR',
  ARTICLE_SELECTOR = ':ARTICLE_SELECTOR',
  INVOICE_SELECTOR = ':INVOICE_SELECTOR',
  SUGGESTION_SELECTOR = ':SUGGESTION_SELECTOR',
  TICKET_SELECTOR = ':TICKET_SELECTOR',
  LOGIN_SELECTOR = ':LOGIN_SELECTOR',
  TIMESLOT_SELECTOR = ':TIMESLOT_SELECTOR',
  SCHEDULED_CALLBACKS_LIST_SELECTOR = ':SCHEDULED_CALLBACKS_LIST_SELECTOR',
  USER_ACCOUNTS_SELECTOR = ':USER_ACCOUNTS_SELECTOR',
  INTENT_SELECTOR = ':INTENT_SELECTOR',
  // It's a types for messages in chat
  CHANGE_MODE = ':CHANGE_MODE',
  AGENT_STATUS = ':AGENT_STATUS',
  AGENT_MESSAGE = ':AGENT_MESSAGE',
  CHAT_TRANSFERRED = ':CHAT_TRANSFERRED',
  WAITING_FOR_AGENT = ':WAITING_FOR_AGENT',
}

export enum SELECTOR_TYPE_RPC {
  ':PHONE_SELECTOR' = 'PHONE_SELECTOR',
  ':ARTICLE_SELECTOR' = 'ARTICLE_SELECTOR',
  ':INVOICE_SELECTOR' = 'INVOICE_SELECTOR',
  ':DOMAIN_SELECTOR' = 'DOMAIN_SELECTOR',
  ':TICKET_SELECTOR' = 'TICKET_SELECTOR',
  ':PLAN_SELECTOR' = 'PLAN_SELECTOR',
  ':SITE_SELECTOR' = 'SITE_SELECTOR',
  ':SUGGESTION_SELECTOR' = 'SUGGESTION_SELECTOR',
  ':TIMESLOT_SELECTOR' = 'TIMESLOT_SELECTOR',
  ':SCHEDULED_CALLBACKS_LIST_SELECTOR' = 'SCHEDULED_CALLBACKS_LIST_SELECTOR',
  ':SUCCESS_SUGGESTIONS_SELECTOR' = 'SUCCESS_SUGGESTIONS_SELECTOR',
  ':USER_ACCOUNTS_SELECTOR' = 'USER_ACCOUNTS_SELECTOR',
  ':INTENT_SELECTOR' = 'INTENT_SELECTOR',
}

export enum SELECTOR_TYPE_TO_ITEM_NAME {
  ':PHONE_SELECTOR' = 'phoneSelector',
  ':ARTICLE_SELECTOR' = 'articleSelector',
  ':INVOICE_SELECTOR' = 'invoiceSelector',
  ':DOMAIN_SELECTOR' = 'domainSelector',
  ':TICKET_SELECTOR' = 'ticketSelector',
  ':PLAN_SELECTOR' = 'planSelector',
  ':SITE_SELECTOR' = 'siteSelector',
  ':SUGGESTION_SELECTOR' = 'suggestionSelector',
  ':TIMESLOT_SELECTOR' = 'timeslotSelector',
  ':SCHEDULED_CALLBACKS_LIST_SELECTOR' = 'scheduledCallbacksListSelector',
  ':SUCCESS_SUGGESTIONS_SELECTOR' = 'successSuggestionsSelector',
  ':USER_ACCOUNTS_SELECTOR' = 'userAccountsSelector',
  ':INTENT_SELECTOR' = 'intentSelector',
}

// It's a types that coming from duplexer
export enum EVENTS_LIVE_CHAT {
  AGENT_REPLIED = 'AGENT_REPLIED',
  AGENT_JOINED = 'AGENT_JOINED',
  AGENT_LEFT = 'AGENT_LEFT',
  CHAT_TRANSFERRED = 'CHAT_TRANSFERRED',
  WAITING_FOR_AGENT = 'WAITING_FOR_AGENT',
}

export enum INTERNAL_MESSAGE {
  START = ':START',
  REDIRECT = ':REDIRECT',
  COLLAPSE_WIDGET = ':COLLAPSE_WIDGET',
  CHANGE_RESTART_CHAT_PARAMETERS = ':CHANGE_RESTART_CHAT_PARAMETERS',
}

export enum UI {
  SELECTOR_CLICKED = 'CHATBOT_UI:SELECTOR_CLICKED',
  CATEGORY_CLICKED = 'CHATBOT_UI:CATEGORY_CLICKED',
  BUTTON_CLICKED = 'CHATBOT_UI:BUTTON_CLICKED',
  CHANGE = 'CHATBOT_UI:CHANGE',
  SEND_MESSAGE = 'CHATBOT_UI:SEND_MESSAGE',
  MODAL_SITE_CLOSE = 'CHATBOT_UI:MODAL_SITE_CLOSE',
  CLOSE_LIVE_CHAT = 'CHATBOT_UI:CLOSE_LIVE_CHAT',
  CANT_LOGIN_CLICKED = 'CHATBOT_UI:CANT_LOGIN_CLICKED',
  NAVIGATED = 'CHATBOT_UI:NAVIGATED',
}

export enum MODAL {
  SITE = ':MODAL_SITE',
}

export enum MODE {
  chatbot = 'chatbot',
  live_chat = 'live-chat',
}

export enum ROUTES {
  MAIN = '/',
  SUPPORT_CHATBOT = '/support-chatbot',
  CONTACT = '/contact',
  WIDGET = '/widget',
  WIDGET_ALL = '/widget/*',
  POST_LOGIN = '/post-login',
  CHATBOT_API = '/api/chatbot',
  WIDGET_API = '/api/widget',
  USER_ACTION = '/api/user-action',
  ARTICLES_SEARCH = '/api/search',
  START_CHAT = '/api/start-chat',
  CONTEXT = '/api/context',
  HELP_CENTER_SESSION = '/api/help-center-session',
  RESTART_CHAT = '/api/restart-chat',
  GET_LIVE_CHAT_MESSAGES = '/api/messages',
  MEDIA_TOKEN = '/api/media-token',
  WIDGET_RUNTIME_DATA = '/api/widget-runtime-data',
  MESSAGE_API = '/api/message',
  ARTICLE_API = '/api/article',
  REQUEST_SUCCESS_MANAGER = '/api/request-success-manager',
  META_ARTIFACT_VERSION = '/meta/artifact-version',
}

export enum MESSAGE_ROUTES {
  MARK_AS_READ = '/mark-as-read',
}

export enum WIDGET_ROUTES {
  MODEL = '/model',
  INIT = '/init',
  RUNTIME = '/runtime',
  SESSION = '/session',
  PERSONALIZATION = '/personalization',
  HOMEPAGE = '/homepage',
  RECOMMENDED_ARTICLES = '/recommended-articles',
}

export enum CHATBOT_ROUTES {
  INIT = '/init',
  DEALER_OFFER = '/offer',
  SESSION = '/session',
  START_CHAT = '/start-chat',
}

export enum EXTERNAL_ROUTES {
  INCIDENTS_TEST = 'https://apps.wix.com/answers-wix-integration/urgent-banner',
  INCIDENTS = 'https://status.wix.com/api/v2/incidents.json',
}

export enum ARTICLE_ROUTES {
  VOTE = '/vote/:articleId',
}
